/* =====================================================================
   LA CINTA DE «SESIÓN DE SOPORTE» · R-SUP (20 de septiembre de 2026)
   =====================================================================
   Cuando quien está dentro es soporte de TEGO entrando como el dueño de
   la empresa, la pantalla lo dice arriba, todo el rato, sin que se pueda
   cerrar: quién es, hasta qué hora, y que es solo lectura. Es la marca
   visual que el dueño pidió: una sesión de soporte no puede confundirse
   con una sesión normal, ni para el operador ni para quien mire por
   encima de su hombro.

   De dónde sale: `abrir` (backend/app/consola/soporte.py) deja en el
   navegador el usuario con `soporte: { operador, motivo, hasta,
   solo_lectura }`. Si no está, esta cinta no pinta nada (TODO-SIRVE).
   La monta el integrador en `AppShell` (una línea): este carril no toca
   los calientes.
   ===================================================================== */
import { useEffect, useState } from 'react';
import { useAuth } from '../lib/contextoAuth';

function horaCorta(iso) {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
}

export default function CintaSoporte() {
  const { usuario } = useAuth();
  const soporte = usuario?.soporte;
  const [ahora, setAhora] = useState(() => Date.now());
  useEffect(() => {
    if (!soporte) return undefined;
    const t = setInterval(() => setAhora(Date.now()), 30000);
    return () => clearInterval(t);
  }, [soporte]);
  if (!soporte) return null;
  const hasta = new Date(soporte.hasta).getTime();
  const quedan = Number.isNaN(hasta) ? null : Math.max(0, Math.round((hasta - ahora) / 60000));
  return (
    <div role="status" data-cinta="soporte"
         className="bg-amber-100 text-amber-900 border-b border-amber-300 text-sm px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1">
      <strong>Sesión de soporte de TEGO</strong>
      <span>{soporte.operador} entró como el dueño para: «{soporte.motivo}».</span>
      <span>
        Solo lectura: aquí no se cambia nada.
        {quedan === null ? '' : quedan === 0
          ? ' Se acabó el tiempo: la siguiente acción cerrará la sesión.'
          : ` Termina a las ${horaCorta(soporte.hasta)} (${quedan} min).`}
      </span>
    </div>
  );
}
